import React from 'react'
import AboutSection from '../components/AboutSection'
import Qoute from '../components/Qoute'
import HoverRevealBox from '../components/HoverRevealBox'

export default function AboutUs() {
  return (
    <>
    <div className='page-container pt-5' >

    <AboutSection />
   
    <div style={{minHeight:'70vh'}}>
      <div className='description-grid mt-5' style={{backgroundImage: 'none'}} >
        <h3 className='w-100'  data-aos="fade-right" >Our Services.</h3>
          <div className='pl-3'>
            <p className='description-0'  data-aos="fade-left">Nabaki is a one-stop development shop. Our consultancy services are<br/>
            rooted in us deep knowledge of ourindustry, and help to ensure that our<br/>
            clients identify and harness development opportunities as they arise.<br/>
            Through our valued partnerships, we ensure that we deliver exactly what<br/>
            our clients require.<br/><br/>
            In each division, ourteams of skilled professionals deliver a vastrange of<br/>
            quality services on projects of all sizes. These services are specifically<br/>
            tailored to our clients ‘needs, and deliver superiorresults in every<br/>
            instance.</p>
        </div>
      </div>
      
      <div id='about-affilations' className='img-boxes mb-4 mt-5 mb-5'>
      <div data-aos="fade-right" >
        <HoverRevealBox 
            label={'Interior Fit Out Contractor'}
            imageSrc={'../assests/imgs/empty-flat-interrior-with-elements-decoration (1).webp'} 
            preview={true}
            forcePreview={false}
            />
            </div>
          <div data-aos="fade-right" data-aos-delay='200'>

          <HoverRevealBox 
          label={'Civils Infrastructure Contractor'}
          imageSrc={'../assests/imgs/workers-construction-site.webp'} 
          />
          </div>
          <div data-aos="fade-right" data-aos-delay='400'>
          <HoverRevealBox 
          label={'Water and Sanitation Infrastructure Contractor'}
          imageSrc={'../assests/imgs/Home Page Click Through/water-and-sanitation.jpg'} 
          />
          </div>
        
              
      </div>
      </div>
      <div id='about-partnerships' className='border-top description-grid  '>
        <div className="abs-bg-shadow" style={{width:'100vw', margin: '0 -2rem'}}></div>
          <div className='bg-img p-5' style={{zIndex: -2}} >
              <h3  data-aos="fade-down" className='heading text-white' >Private and<br/>
              Public Partnerships</h3>
          </div >
          <div  data-aos="fade-up" className='description-0 small pt-4 pb-5'>
            Ongoing changes in the growth and development of the company<br/>
            have encouraged us to ensure that we take maximum advantage<br/>
            of opportunities in the marketplace.<br/><br/>
            We have seen a definite shift in industry trends resulting in a decline in<br/>
            traditional public sector work and an increase in Private-Public<br/>
            Partnerships. We believe this a consequence of Governments not<br/>
            being unable to singlehandedly carry the burden of infrastructure<br/>
            development brought on by many competing socio-political priorities.<br/>

          </div>

      </div>
      
    </div>
    <Qoute />
    </>
  )
}
